import { useParams } from "react-router-dom"
import { Container, Row, Col } from "react-bootstrap"
import { useGetScrapeEntryByIdQuery } from "../../../services/bClientApi"
import ScrapeEntryEntry from "../../../Components/ScrapeEntry/ScrapeEntryEntry/ScrapeEntryEntry"

export default function ScrapeEntryPage() {
    const { scrapeEntryId = '' } = useParams()

    const {
        data,
        error,
        isLoading
    } = useGetScrapeEntryByIdQuery(scrapeEntryId, { skip: !scrapeEntryId })
    const scrapeEntryData = data || {}

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Scrape Entry Details</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {scrapeEntryId && scrapeEntryData && scrapeEntryData._id && !isLoading && (
                        <ScrapeEntryEntry
                            scrapeEntryData={scrapeEntryData}
                            fullView={true}
                        />
                    )}
                </Col>
            </Row>
        </Container>
    )
}